import {AccountService} from './accountService.js';
import {BundlePromotionService} from './bundlePromotionService.js';
import {CustomerApplicationService} from './customerApplicationService.js';
import {ProductService} from './productService.js';
import {ReferralService} from './referralService.js';
import {SalesRepService} from './saleRepService.js';
import {TchAccountService} from './tchAccountService.js';
import {ReferenceCompanyService} from './referenceCompanyService.js';

export var BillingService = {
	accountService: null,
	bundlePromotionService: null,
	customerApplicationService: null,
	productService: null,
	referralService: null,
	salesRepService: null,
	tchAccountService: null,
	referenceCompanyService: null,
	
	getAccountService: function(){
		if (!this.accountService) {
			this.accountService = new AccountService();
		}
		return this.accountService;
	},
	
	getBundlePromotionService: function(){
		if (!this.bundlePromotionService) {
			this.bundlePromotionService = new BundlePromotionService();
		}
		return this.bundlePromotionService;
	},
	
	getCustomerApplicationService: function(){
		if (!this.customerApplicationService) {
			this.customerApplicationService = new CustomerApplicationService();
		}
		return this.customerApplicationService;
	},
	
	getProductService: function(){
		if (!this.productService) {
			this.productService = new ProductService();
		}
		return this.productService;
	},
	
	getReferenceCompanyService: function(){
		if (!this.referenceCompanyService) {
			this.referenceCompanyService = new ReferenceCompanyService();
		}
		return this.referenceCompanyService;
	},	
	
	getReferralService: function(){
		if (!this.referralService) {
			this.referralService = new ReferralService();
		}
		return this.referralService;
	},
	
	getSalesRepService: function(){
		if (!this.salesRepService) {
			this.salesRepService = new SalesRepService();
		}
		return this.salesRepService;
	},
	
	getTchAccountService: function(){
		if (!this.tchAccountService) {
			this.tchAccountService = new TchAccountService();
		}
		return this.tchAccountService;
	}	
	
};

